import {combineReducers} from "redux"
import { loaderReducer } from "./loaderReducer"
import ToastReducer from "./toastReducer"
import distributorInfoReducer from "./distributorInfoReducer"

import EmployeeInfoReducer from "./employeeInfoReducer"
import investorInfoReducer from "./investorInfoReducer"
import schemeInfoReducer from "./schemeInfoReducer"
import userReducer from "./userReducer"
import allSchemeDetailsReducer from "./allSchemeDetailsReducer"
import allInvestorDetailsReducer from "./allInvestorDetailsReducer"
import emailTemplateInfoReducer from "./emailTemplateInfoReducer"
import allEmailTemplateDetailsReducer from "./allEmailTemplateDetailsReducer"
import schemeInfoAgainstInvestor from "./schemeInfoAgainstInvestorReducer"
import { getAUMDataAgainstScheme } from "../actions/aumDataAgainstSchemeAction"
import schemeInfoAgainstInvestorReducer from "./schemeInfoAgainstInvestorReducer"
import aumDataAgainstSchemeReducer from "./aumDataAgainstSchemeReducer"

export const myReducer =combineReducers(
    {

        loader:loaderReducer,
        toast:ToastReducer,
        distributorInfo:distributorInfoReducer,
        investorInfo:investorInfoReducer,
        employeeInfo:EmployeeInfoReducer,
        schemeInfo:schemeInfoReducer,
        user:userReducer,
        allSchemeDetails:allSchemeDetailsReducer,
        allInvestorDetails:allInvestorDetailsReducer,
        emailTemplateInfo:emailTemplateInfoReducer,
        allEmailTemplateDetails:allEmailTemplateDetailsReducer,
        schemeInfoAgainstInvestor:schemeInfoAgainstInvestorReducer,
        aumDataAgainstScheme:aumDataAgainstSchemeReducer
    })
